import React from "react";
import { useTranslation } from "react-i18next";
import "./music.css";
import SectionWrapper from "../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../components/BreathingBackground/BreathingBackground";
import MusicPlayer from "../components/MusicPlayer/MusicPlayer";

const Music = () => {
  const { t } = useTranslation();

  return (
    <BreathingBackground>
    <SectionWrapper>
    <section className="music-page">
      {/* INTRO */}
      <header className="music-hero">
        <h1>{t("music.title", "La Música de Kujipy")}</h1>
        <p>
          {t(
            "music.intro",
            "La música de Kujipy nace de la tradición mixe de Oaxaca. Es música de viento pensada para acompañar el baile, la fiesta comunitaria y la relación con la tierra."
          )}
        </p>
      </header>

      <MusicPlayer />

      {/* SONIDO */}
      <section className="music-section">
        <h2>{t("music.soundTitle", "Música de viento mixe")}</h2>
        <p>
          {t(
            "music.soundText",
            "Kujipy interpreta música tradicional mixe utilizando banda de viento. Los sonidos acompañan celebraciones, rituales y encuentros comunitarios, donde la música no se escucha en silencio: se baila y se comparte."
          )}
        </p>
      </section>

      {/* OBRA DESTACADA */}
      <section className="music-section highlight">
        <h2>{t("music.workTitle", "Obra destacada: El Baile de la Tuza (Baltiptsy)")}</h2>
        <p>
          {t(
            "music.workText",
            "El Baile de la Tuza es una pieza representativa del repertorio de Kujipy. La canción cuenta la historia de una tuza que come maíz y chayote, símbolo de la relación entre la comunidad, la tierra y el alimento."
          )}
        </p>

        <p>
          {t(
            "music.workText2",
            "Esta obra es interpretada en contextos festivos y se baila colectivamente, convirtiéndose en una experiencia viva más que en una pieza musical fija."
          )}
        </p>

        <a href="/music/baltiptsy" className="editorial-link">
          {t("music.more", "Conocer el Baile de la Tuza")}
        </a>
      </section>

      {/* EXPERIENCIA EN VIVO */}
      <section className="music-section">
        <h2>{t("music.liveTitle", "Experiencia en vivo")}</h2>
        <p>
          {t(
            "music.liveText",
            "La presentación de Kujipy en vivo combina música, baile y participación del público. No es un concierto tradicional, sino una experiencia cultural que invita al movimiento y al encuentro."
          )}
        </p>
      </section>

      <div className="epk-inline">
      <p>
        {t("home.bookingLabel")}:
        <a
          href="/epk"
          className="editorial-link"
          target="_self"
        >
          {t("home.viewEpk")}
        </a>
      </p>
    </div>

      {/* ESCUCHAR */}
      <section className="music-section listen">
        <h2>{t("music.listenTitle", "Escuchar")}</h2>

        <div className="listen-links">
          <a
            href="https://open.spotify.com/artist/3tDuuuTkPprgYHtL7QsvXs"
            className="editorial-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Spotify
          </a>
          <a
            href="https://www.youtube.com/@kujipyoficial8421"
            className="editorial-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            YouTube
          </a>
        </div>
      </section>
    </section>
    </SectionWrapper>
    </BreathingBackground>
  );
};

export default Music;
